/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Investor_AddInputs */

const cs_investor_add = /** @type {(inputs: Investor_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přidat profil`)
};

const en_investor_add = /** @type {(inputs: Investor_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add profile`)
};

/**
* | output |
* | --- |
* | "Add profile" |
*
* @param {Investor_AddInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const investor_add = /** @type {((inputs?: Investor_AddInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Investor_AddInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_investor_add(inputs)
	return cs_investor_add(inputs)
});